import React from 'react';
import ReactDOM from 'react-dom';

const DeleteConfirmDialog = ({ isOpen, onConfirm, onCancel, confirmationText, setConfirmationText, deviceName }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div 
      className="delete-dialog-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 10001,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      onClick={onCancel}
    >
      <div 
        className="delete-dialog-content"
        style={{
          backgroundColor: 'white',
          padding: '25px',
          borderRadius: '8px',
          minWidth: '400px',
          maxWidth: '500px',
          boxShadow: '0 4px 15px rgba(0,0,0,0.3)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ 
          color: '#dc3545', 
          margin: '0 0 15px 0', 
          fontSize: '18px',
          fontWeight: 'bold'
        }}>
          Confirm Deletion
        </h3>
        
        <p style={{ 
          margin: '0 0 15px 0', 
          fontSize: '14px',
          color: '#333',
          lineHeight: '1.4'
        }}>
          Are you sure you want to delete device <strong>{deviceName}</strong>? This operation cannot be reverted. Type <strong>"DELETE"</strong> to confirm deletion.
        </p>

        <input
          type="text"
          value={confirmationText}
          onChange={(e) => setConfirmationText(e.target.value)}
          placeholder="DELETE"
          style={{
            width: '100%',
            padding: '10px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            fontSize: '14px',
            marginBottom: '15px',
            boxSizing: 'border-box'
          }}
          autoFocus
          onKeyDown={(e) => {
            if (e.key === 'Enter' && confirmationText === 'DELETE') {
              onConfirm();
            }
          }}
        />

        <div style={{ 
          display: 'flex', 
          gap: '10px', 
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={onCancel}
            style={{
              padding: '10px 20px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '14px',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#5a6268'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#6c757d'}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={confirmationText !== 'DELETE'}
            style={{
              padding: '10px 20px',
              backgroundColor: confirmationText === 'DELETE' ? '#dc3545' : '#ccc',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '14px',
              cursor: confirmationText === 'DELETE' ? 'pointer' : 'not-allowed',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              if (confirmationText === 'DELETE') {
                e.target.style.backgroundColor = '#c82333';
              }
            }}
            onMouseLeave={(e) => {
              if (confirmationText === 'DELETE') {
                e.target.style.backgroundColor = '#dc3545';
              }
            }}
          >
            Delete
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DeleteConfirmDialog;
